export default async function init() {
  const gradients = document.querySelectorAll('[data-js-module="movingGradient"]');

  const initGradient = async () => {
    const { default: MovingGradient } = await import(/* webpackChunkName: "movingGradient" */ './movingGradient');
    gradients.forEach((modal) => new MovingGradient(modal));
  };

  if (gradients.length) initGradient();
}

init();
